export const environment = {
  production: true,
  env: 'production',
  version: '2.0.1',
  webHost: 'www.sportsinformations.com',
  facebook_key: '814221563686589',
  google_key: '659145080826-ii7bqn8rdbfhsecebeo74p9ks8niq56k.apps.googleusercontent.com',
};